'use client';

import { TypeButtonLinkComponentWithoutUnresolvableLinksResponse } from '@shared/features/contentful/_generated';
import { resolveContentfulTargetProps } from '@shared/features/contentful/linkMap';

import {
    LightRetouchButton,
    LightRetouchButtonSize,
    LightRetouchButtonVariant,
} from '@shared/light-retouch';
import { redirectThroughLandingPageJoin } from '@lp/features/landingPageHandoff/redirectThroughLandingPageJoin';
import styles from './HeaderLink.module.scss';

interface HeaderLinkProps {
    linkItem: TypeButtonLinkComponentWithoutUnresolvableLinksResponse;
    variant?: LightRetouchButtonVariant;
}

export default function HeaderLink({
    linkItem,
    variant = LightRetouchButtonVariant.Primary,
}: HeaderLinkProps) {
    const { link = '#', target, title, type } = linkItem.fields;
    const isButton = type === true;

    if (isButton) {
        return (
            <LightRetouchButton
                onClick={() => {
                    redirectThroughLandingPageJoin({
                        openInNewTab: target === '_blank',
                    });
                }}
                aria-label={title}
                variant={variant}
                size={LightRetouchButtonSize.Compact}
                className={styles.link}
            >
                {title}
            </LightRetouchButton>
        );
    }

    return (
        <LightRetouchButton
            href={link}
            {...resolveContentfulTargetProps(target)}
            aria-label={title}
            variant={variant}
            size={LightRetouchButtonSize.Compact}
            className={styles.link}
        >
            {title}
        </LightRetouchButton>
    );
}
